/* eslint-disable no-unused-expressions */
/* eslint-disable no-unused-vars */
import { useState, useEffect, useRef, Fragment } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { motion, AnimatePresence } from 'framer-motion';
import {
  Autocomplete,
  Avatar,
  Backdrop,
  Box,
  Button,
  Card,
  Checkbox,
  CircularProgress,
  Divider,
  IconButton,
  InputAdornment,
  Link,
  Paper,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Tabs,
  TextField,
  Typography
} from '@material-ui/core';
import ArrowRightIcon from '../../../icons/ArrowRight';
import TrashIcon from '../../../icons/Trash';
import SearchIcon from '../../../icons/Search';
import Scrollbar from '../../Scrollbar';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { customerApi } from '../../../api/customerApi';
import regions from './regions';
import * as Yup from 'yup';
import { Formik } from 'formik';
import toast from 'react-hot-toast';
import useAuth from '../../../hooks/useAuth';
import { CSVLink } from 'react-csv';
import * as moment from 'moment';
import { withStyles } from '@mui/styles';
// import { withStyles } from '@mui/styles';

const tabs = [
  {
    label: 'Tous',
    value: 'all'
  }
];

export const stringToColor = (string) => {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.substr(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
};

export const stringAvatar = (name) => ({
  sx: {
    bgcolor: stringToColor(name),
  },
  children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`,
});

// Couleur du score relation client (colonne "Score IA")
const scoreIaColor = (s) => {
  if (s >= 80) return '#10b981';
  if (s >= 60) return '#3b82f6';
  if (s >= 40) return '#f59e0b';
  if (s >= 20) return '#f97316';
  return '#ef4444';
};

const newCallTrackOptions = [
  {
    label: 'Tous',
    value: 'all'
  },
  {
    label: 'Sans statut',
    value: 'empty'
  },
  {
    label: 'Vente 1 formation',
    value: 'Vente 1 formation'
  },
  {
    label: 'Vente 2 formation',
    value: 'Vente 2 formation'
  },
  {
    label: 'Vente 3 formation',
    value: 'Vente 3 formation'
  },
  {
    label: 'Déjà validé',
    value: 'Déjà validé'
  },
  {
    label: 'Souhaite du présentiel',
    value: 'Souhaite du présentiel'
  },
  {
    label: 'Aucun thème voulu',
    value: 'Aucun thème voulu'
  },
  {
    label: 'Date de session trop proche',
    value: 'Date de session trop proche'
  },
  {
    label: 'Préfère un autre organisme',
    value: 'Préfère un autre organisme'
  },
  {
    label: 'Retraite',
    value: 'Retraite'
  },
  {
    label: 'Numéro incorrect',
    value: 'Numéro incorrect'
  },
  {
    label: 'Non professionnel de santé',
    value: 'Non professionnel de santé'
  },
  {
    label: 'Souhaite un email',
    value: 'Souhaite un email'
  },
  {
    label: 'Rappel',
    value: 'Rappel'
  },
  {
    label: 'Attente',
    value: 'Attente'
  },
  {
    label: 'Appel entrant',
    value: 'Appel entrant'
  },
  {
    label: 'Pas répondu',
    value: 'Pas répondu'
  },
];

const callTrackRelanceOptions = [
  {
    label: 'Tous',
    value: 'all'
  },
  {
    label: 'Sans statut',
    value: 'empty'
  },
  {
    label: 'Pas répondu',
    value: 'Pas répondu'
  },
  {
    label: 'À rappeler',
    value: 'À rappeler'
  },
  {
    label: 'Numéro incorrect',
    value: 'Numéro incorrect'
  },
  {
    label: 'Va se connecter',
    value: 'Va se connecter'
  },
  {
    label: 'Suivi - Téléphone',
    value: 'Suivi - Téléphone'
  },
  {
    label: 'Suivi - Mail',
    value: 'Suivi - Mail'
  },
  {
    label: 'Suivi - SMS',
    value: 'Suivi - SMS'
  },
  {
    label: 'Décalage',
    value: 'Décalage'
  },
  {
    label: 'Annulation',
    value: 'Annulation'
  }
];

const sortOptions = [
  {
    label: 'Fin de session plus proche',
    value: 'minSession|asc'
  },
  {
    label: 'Fin de session plus éloignée',
    value: 'minSession|desc'
  },
  {
    label: 'Nom (A - Z)',
    value: 'lastname|asc'
  },
  {
    label: 'Nom (Z - A)',
    value: 'lastname|desc'
  },
  {
    label: 'Code postal (plus petit)',
    value: 'zip|asc'
  },
  {
    label: 'Code postal (plus grand)',
    value: 'zip|desc'
  }
];

const avancementOptions = [
  {
    label: 'Tous',
    value: 'all'
  },
  {
    label: 'Pas commencé',
    value: 'Pas commencé'
  },
  {
    label: 'En cours',
    value: 'En cours'
  },
  {
    label: 'Terminé',
    value: 'Terminé'
  },
];

const applyFilters = (customers, query, filters, source, campaign, callTrack, newCallTrack, callTrackRelance, avancement, relance, finSessions,
  customersEndSessions, isRelance, modeRelance) => customers
  .filter((customer) => {
    const matches = true;

    return matches;
  });

const applyPagination = (customers, page, limit) => customers;

const descendingComparator = (a, b, orderBy) => {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }

  if (b[orderBy] > a[orderBy]) {
    return 1;
  }

  return 0;
};

const getComparator = (order, orderBy) => (order === 'desc'
  ? (a, b) => descendingComparator(a, b, orderBy)
  : (a, b) => -descendingComparator(a, b, orderBy));

const applySort = (customers, sort) => {
  const [orderBy, order] = sort.split('|');
  const comparator = getComparator(order, orderBy);
  const stabilizedThis = customers.map((el, index) => [el, index]);

  stabilizedThis.sort((a, b) => {
    const newOrder = comparator(a[0], b[0]);

    if (newOrder !== 0) {
      return newOrder;
    }

    return a[1] - b[1];
  });

  return stabilizedThis.map((el) => el[0]);
};

const handleDeleteCustomer = async (customerId) => {
  try {
    await customerApi.deleteCustomer(customerId, localStorage.getItem('accessToken'));
    window.location.reload();
  } catch (err) {
    console.log(err);
  }
};

const CustomerListTable = (props) => {
  const { customers, usersCampaign, modeRelance, isRelance, usersRelance, endSessions, customersEndSessions, choiceTabProfession,
    choiceSort, choiceSource, choiceCampaign, choiceCallTrack, choiceNewCallTrack, choiceCallTrackRelance, choiceAvancement, choiceEndSession, query, setQuery, setCustomers,
    numberCustomers, setNumberCustomers, setKpiCounts, loading, loadingFilter, page, setPage, limit, setLimit, relance, setRelance, ...other } = props;
  const { user } = useAuth();
  let tempChoiceTab = window.localStorage.getItem('choiceTabProfession');
  tempChoiceTab = tempChoiceTab === null ? 'all' : window.localStorage.getItem('choiceTabProfession').replaceAll('"', '');
  const [currentTab, setCurrentTab] = useState(tempChoiceTab);
  const [dynamicTabs, setDynamicTabs] = useState(tabs);
  let tempChoiceSource = window.localStorage.getItem('choiceSource');
  tempChoiceSource = tempChoiceSource === null ? 'all' : window.localStorage.getItem('choiceSource').replaceAll('"', '');
  const [currentSource, setCurrentSource] = useState(tempChoiceSource);
  let tempChoiceCampaign = window.localStorage.getItem('choiceCampaign');
  tempChoiceCampaign = tempChoiceCampaign === null ? 'all' : window.localStorage.getItem('choiceCampaign').replaceAll('"', '');
  const [currentCampaign, setCurrentCampaign] = useState(tempChoiceCampaign);
  let tempChoiceCallTrack = window.localStorage.getItem('choiceCallTrack');
  tempChoiceCallTrack = tempChoiceCallTrack === null ? 'all' : window.localStorage.getItem('choiceCallTrack').replaceAll('"', '');
  const [currentCallTrack, setCurrentCallTrack] = useState(tempChoiceCallTrack);
  let tempChoiceNewCallTrack = window.localStorage.getItem('choiceNewCallTrack');
  tempChoiceNewCallTrack = tempChoiceNewCallTrack === null ? 'all' : window.localStorage.getItem('choiceNewCallTrack').replaceAll('"', '');
  const [currentNewCallTrack, setCurrentNewCallTrack] = useState(tempChoiceNewCallTrack);
  let tempChoiceNewCallTrackRelance = window.localStorage.getItem('choiceNewCallTrackRelance');
  tempChoiceNewCallTrackRelance = tempChoiceNewCallTrackRelance === null ? 'all' : window.localStorage.getItem('choiceNewCallTrackRelance').replaceAll('"', '');
  const [currentCallTrackRelance, setCurrentCallTrackRelance] = useState(tempChoiceNewCallTrackRelance);
  const tempChoiceEndSession = window.localStorage.getItem('choiceEndSession');
  const [currentEndSessions, setCurrentEndSessions] = useState(tempChoiceEndSession === null ? 'all' : window.localStorage.getItem('choiceEndSession').replaceAll('"', ''));
  const tempChoiceRelance = window.localStorage.getItem('choiceRelance');
  const [currentRelance, setCurrentRelance] = useState(tempChoiceRelance === null ? 'all' : window.localStorage.getItem('choiceRelance').replaceAll('"', ''));
  let tempChoiceAvancement = window.localStorage.getItem('choiceAvancement');
  tempChoiceAvancement = tempChoiceAvancement === null ? 'all' : window.localStorage.getItem('choiceAvancement').replaceAll('"', '');
  const [currentAvancement, setCurrentAvancement] = useState(tempChoiceAvancement);
  let tempChoiceRegion = window.localStorage.getItem('choiceRegion');
  tempChoiceRegion = tempChoiceRegion === null ? 'all' : window.localStorage.getItem('choiceRegion').replaceAll('"', '');
  const [currentRegion, setCurrentRegion] = useState(tempChoiceRegion);
  let tempChoiceCity = window.localStorage.getItem('choiceCity');
  tempChoiceCity = tempChoiceCity === null ? '' : window.localStorage.getItem('choiceCity').replaceAll('"', '');
  const [currentVille, setCurrentVille] = useState(tempChoiceCity);
  let tempChoiceStatut = window.localStorage.getItem('choiceStatus');
  tempChoiceStatut = tempChoiceStatut === null ? 'all' : window.localStorage.getItem('choiceStatus').replaceAll('"', '');
  const [currentStatut, setCurrentStatut] = useState(tempChoiceStatut);
  const villeDebounceRef = useRef(null);
  const [relationScores, setRelationScores] = useState({});
  const [selectedCustomers, setSelectedCustomers] = useState([]);
  const [open, setOpen] = useState(false);
  const [customerDelete, setCustomerDelete] = useState({});
  // partie autocomplete chercher un apprenant

  const [loadingAutocomplete, setLoadingAutocomplete] = useState(false);
  const [openAutoComplete, setOpenAutocomplete] = useState(false);
  const [optionsSearch, setOptionsSearch] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  const [isSearching, setIsSearching] = useState(false);

  // Fonction pour charger les professions distinctes depuis learner_session
  const loadDynamicProfessions = async () => {
    try {
      const professions = await customerApi.getDistinctProfessionsFromLearnerSession(localStorage.getItem('accessToken'));
      if (professions && professions.length > 0) {
        const newTabs = [
          {
            label: 'Tous',
            value: 'all'
          },
          ...professions.map(prof => ({
            label: prof.profession,
            value: prof.profession
          }))
        ];
        setDynamicTabs(newTabs);
      }
    } catch (err) {
      console.error('Erreur lors du chargement des professions:', err);
    }
  };

  const [finSessions, setFinSessions] = useState({ '2022-02-28': null });

  // pour que tous les ordis puissent fonctionner sans l'ancien filtre statut d'appel
  useEffect(() => {
    setCurrentCallTrack('all');
    window.localStorage.setItem('choiceCallTrack', JSON.stringify('all'));
  }, []);

  // Charger les professions dynamiques au montage du composant
  useEffect(() => {
    loadDynamicProfessions();
  }, []);

  const [source, setSource] = useState({
    0: null,
    998: null,
    999: null
  });

  const [avancement, setAvancement] = useState({
    'Pas commencé': null,
    'En cours': null,
    Terminé: null
  });

  function initCampaign() {
    const camp = {};
    usersCampaign.forEach((element) => {
      camp[element.id] = null;
    });
    camp.empty = null;
    return camp;
  }

  const [campaign, setCampaign] = useState(initCampaign);

  let tempChoiceSort = window.localStorage.getItem('choiceSort');
  tempChoiceSort = tempChoiceSort === null ? 'lastname|asc' : window.localStorage.getItem('choiceSort').replaceAll('"', '');
  const [sort, setSort] = useState(tempChoiceSort);
  const [callTrack, setCallTrack] = useState({
    empty: null,
    'Pas répondu': null,
    'À rappeler': null,
    'Numéro incorrect': null,
    Vente: null,
    'Non - Déjà fait': null,
    'Non - Pas intéressé': null,
    Attente: null
  });
  const [newCallTrack, setNewCallTrack] = useState({
    empty: null,
    'Vente 1 formation': null,
    'Vente 2 formation': null,
    'Vente 3 formation': null,
    'Déjà validé': null,
    'Souhaite du présentiel': null,
    'Aucun thème voulu': null,
    'Date de session trop proche': null,
    'Préfère un autre organisme': null,
    Retraite: null,
    'Numéro incorrect': null,
    'Non professionnel de santé': null,
    'Souhaite un email': null,
    Rappel: null,
    Attente: null,
    'Appel entrant': null,
    'Pas répondu': null
  });
  const [callTrackRelance, setCallTrackRelance] = useState({
    empty: null,
    'Pas répondu': null,
    'À rappeler': null,
    'Numéro incorrect': null,
    'Va se connecter': null,
    Annulation: null,
    'Suivi - Téléphone': null,
    'Suivi - Mail': null,
    'Suivi - SMS': null,
    Décalage: null,
  });
  const [filters, setFilters] = useState({});

  const usersCampaignList = [...usersCampaign];
  usersCampaignList.unshift({ firstname: 'Tous', lastname: '', id: 'all' });
  usersCampaignList.push({ firstname: 'Non ', lastname: 'assignés', id: 0 });

  const usersRelanceList = [...usersRelance];
  usersRelanceList.unshift({ firstname: 'Tous', lastname: '', id: 'all' });
  usersRelanceList.push({ firstname: 'Non ', lastname: 'assignés', id: 0 });

  const location = useLocation();

  // garde anti-race : seule la reponse de la DERNIERE requete lancee met a jour l'affichage
  const latestRequest = useRef(0);
  const handleCustomers = (async (querySearch, sortChange, sourceChange, campaignChange, callTrackChange, newCallTrackChange, callTrackRelanceChange,
    avancementChange, finSessionsChange, relanceChange, tabProfession, limitChoice, pageChoice, modeRelanceChange, isBigSearch = true, displaySpinnerTable = false) => {
    const requestId = ++latestRequest.current;
    try {
      // si le spinner de la page n'est pas actif (loading), on déclenche le spinner de la table des apprenants au chargement des données
      if (!loading && displaySpinnerTable) {
        setIsLoading(true);
      }
      setIsSearching(true);
      // Filtres région / ville / statut : lus depuis le localStorage pour rester synchronisés
      // quel que soit le filtre déclencheur (les autres handlers n'ont pas à les transmettre).
      let regionChoice = window.localStorage.getItem('choiceRegion');
      regionChoice = regionChoice === null ? 'all' : regionChoice.replaceAll('"', '');
      let cityChoice = window.localStorage.getItem('choiceCity');
      cityChoice = cityChoice === null ? '' : cityChoice.replaceAll('"', '');
      let statusChoice = window.localStorage.getItem('choiceStatus');
      statusChoice = statusChoice === null ? 'all' : statusChoice.replaceAll('"', '');
      // Recherche texte = recherche GLOBALE : on neutralise tous les filtres de liste
      // persistes (profession, source, campagne, statut, region, ville...) pour qu'un filtre
      // oublie en localStorage ne masque pas un apprenant existant. Cause classique du
      // "introuvable" intermittent et difficile a reproduire.
      if (querySearch && String(querySearch).trim() !== '') {
        sourceChange = 'all';
        campaignChange = 'all';
        callTrackChange = 'all';
        newCallTrackChange = 'all';
        callTrackRelanceChange = 'all';
        avancementChange = 'all';
        finSessionsChange = 'all';
        relanceChange = 'all';
        tabProfession = 'all';
        regionChoice = 'all';
        cityChoice = '';
        statusChoice = 'all';
      }
      let data = [];
      if (location.pathname === '/dashboard/customers') {
        const dataCustomers = await customerApi.getCustomersInfos(window.localStorage.getItem('accessToken'), querySearch, sortChange, sourceChange, campaignChange, callTrackChange,
          newCallTrackChange, callTrackRelanceChange, avancementChange, finSessionsChange, relanceChange, tabProfession, limitChoice, pageChoice, modeRelanceChange, true, regionChoice, cityChoice, statusChoice);
        // reponse perimee : une recherche plus recente est en cours, on abandonne (et on evite la 2e requete)
        if (requestId !== latestRequest.current) {
          return;
        }
        setNumberCustomers(dataCustomers.numberCustomers);
        // pendant une recherche texte, le backend renvoie kpiCounts=null (non recalcule pour la perf) :
        // on garde alors les dernieres valeurs des cartes KPI au lieu de les ecraser.
        if (setKpiCounts && dataCustomers.kpiCounts) {
          setKpiCounts(dataCustomers.kpiCounts);
        }
        data = await customerApi.getCustomers(localStorage.getItem('accessToken'), querySearch, sortChange, sourceChange, campaignChange, callTrackChange,
          newCallTrackChange, callTrackRelanceChange, avancementChange, finSessionsChange, relanceChange, tabProfession, limitChoice, pageChoice, modeRelanceChange, isBigSearch, regionChoice, cityChoice, statusChoice);
      } else if (location.pathname === '/dashboard/campagne') {
        data = await customerApi.getCustomersCampagne(window.localStorage.getItem('accessToken'), querySearch, sortChange, sourceChange, campaignChange, callTrackChange,
          newCallTrackChange, callTrackRelanceChange, avancementChange, finSessionsChange, relanceChange, tabProfession, limitChoice, pageChoice, modeRelanceChange, isBigSearch);
        if (requestId !== latestRequest.current) {
          return;
        }
        setNumberCustomers(data.numberCustomers);
      }
      // derniere verification avant d'afficher les lignes
      if (requestId !== latestRequest.current) {
        return;
      }
      if (isBigSearch) {
        setCustomers(data.customers);
      }
      setOptionsSearch(data.customers);
      setIsLoading(false);
      setIsSearching(false);
      setLoadingAutocomplete(false);
    } catch (err) {
      console.error(err);
    }
  });

  // Score IA : chargement (asynchrone, par lot) des scores relation client des apprenants affichés
  useEffect(() => {
    if (!customers || customers.length === 0) {
      return undefined;
    }
    const ids = customers.map((c) => c.id).filter(Boolean);
    if (ids.length === 0) {
      return undefined;
    }
    let active = true;
    customerApi.getRelationScores(ids, window.localStorage.getItem('accessToken'))
      .then((res) => { if (active && res) setRelationScores((prev) => ({ ...prev, ...res })); })
      .catch(() => {});
    return () => { active = false; };
  }, [customers]);

  useEffect(() => {
    // Réinitialisation des sélections
    setSelectedCustomers([]);

    // Réinitialisation du filtre des fin de sessions
    if (!(user.id_service === 4)) {
      setCurrentEndSessions('all');
      !loading ? window.localStorage.setItem('choiceEndSession', JSON.stringify('all')) : '';
    }

    // Réinitialisation du filtre des sources
    const updatedSource = {
      ...source,
      0: null,
      998: null,
      999: null
    };
    !loading ? window.localStorage.setItem('choiceSource', JSON.stringify('all')) : '';
    !loading ? setCurrentSource('all') : '';

    // Réinitialisation du filtre statut d'avancement
    const updatedAvancement = {
      ...avancement,
      'Pas commencé': null,
      'En cours': null,
      Terminé: null
    };
    if (!(user.id_service === 4)) {
      setCurrentAvancement('all');
      !loading ? window.localStorage.setItem('choiceAvancement', JSON.stringify('all')) : '';
    }

    // Réinitialisation du filtre statut d'appel
    const updatedCallTrack = {
      ...callTrack,
      empty: null,
      'Pas répondu': null,
      'À rappeler': null,
      'Numéro incorrect': null,
      Vente: null,
      'Non - Déjà fait': null,
      'Non - Pas intéressé': null,
      Attente: null
    };
    !loading ? window.localStorage.setItem('choiceCallTrack', JSON.stringify('all')) : '';
    !loading ? setCurrentCallTrack('all') : '';

    // Réinitialisation du filtre nouveau statut d'appel
    const updatedNewCallTrack = {
      ...newCallTrack,
      empty: null,
      'Vente 1 formation': null,
      'Vente 2 formation': null,
      'Vente 3 formation': null,
      'Déjà validé': null,
      'Souhaite du présentiel': null,
      'Aucun thème voulu': null,
      'Date de session trop proche': null,
      'Préfère un autre organisme': null,
      Retraite: null,
      'Numéro incorrect': null,
      'Non professionnel de santé': null,
      'Souhaite un email': null,
      Rappel: null,
      Attente: null,
      'Appel entrant': null,
      'Pas répondu': null
    };
    !loading ? window.localStorage.setItem('choiceNewCallTrack', JSON.stringify('all')) : '';
    !loading ? setCurrentNewCallTrack('all') : '';

    // Réinitialisation du filtre statut d'appel relance
    const updatedCallTrackRelance = {
      ...callTrackRelance,
      empty: null,
      'Pas répondu': null,
      'À rappeler': null,
      'Numéro incorrect': null,
      'Va se connecter': null,
      Annulation: null,
      'Suivi - Téléphone': null,
      'Suivi - Mail': null,
      'Suivi - SMS': null,
      Décalage: null,
    };
    if (!(user.id_service === 4)) {
      setCurrentCallTrackRelance('all');
      !loading ? window.localStorage.setItem('choiceCallTrackRelance', JSON.stringify('all')) : '';
    }
    // Réinitialisation du filtre des utilisateurs commerciaux de campagnes
    const tempCampaign = {};
    usersCampaign.forEach((element) => {
      tempCampaign[element.id] = null;
    });
    const updatedCampaign = {
      ...campaign,
      ...tempCampaign,
      0: null
    };
    !loading ? window.localStorage.setItem('choiceCampaign', JSON.stringify('all')) : '';
    !loading ? setCurrentCampaign('all') : '';

    // Réinitialisation du filtre des utilisateurs à la relance
    const tempRelance = {};
    usersRelance.forEach((element) => {
      tempRelance[element.id] = null;
    });
    const updatedRelance = {
      ...relance,
      ...tempRelance,
      0: null
    };
    if (!(user.id_service === 4)) {
      setCurrentRelance('all');
      !loading ? window.localStorage.setItem('choiceRelance', JSON.stringify('all')) : '';
    }

    // réinitialisation du filtre fin de session à la relance
    setCurrentEndSessions('all');
    !loading ? window.localStorage.setItem('choiceEndDate', JSON.stringify('all')) : '';

    // requête en bdd par rapport mode commercial/relance avec réinitialisation des valeurs des filtres
    !loading ? handleCustomers(query, 'minSession|asc', 'all', 'all', 'all', 'all', 'all', 'all', 'all', 'all', 'all', limit, page, modeRelance, true, true) : '';
  }, [modeRelance]);

  const handleSourceChange = (event, value) => {
    const updatedSource = {
      ...source,
      0: null,
      998: null,
      999: null
    };

    if (typeof event.target === 'undefined') {
      if (value !== 'all') {
        updatedSource[value] = true;
      }
      setSource(updatedSource);
      setSelectedCustomers([]);
      setCurrentSource(value);
    } else {
      if (event.target.value !== 'all') {
        updatedSource[event.target.value] = true;
      }
      setSource(event.target.value);
      setSelectedCustomers([]);
      setCurrentSource(event.target.value);
      window.localStorage.setItem('choiceSource', JSON.stringify(event.target.value));
    }
    setPage(0);
    handleCustomers(query, sort, event.target.value, currentCampaign, callTrack, currentNewCallTrack, currentCallTrackRelance, avancement, currentEndSessions, relance, filters, limit, 0, modeRelance, true, true);
  };

  const handleEndSessionsChange = (event) => {
    const updatedEndSessions = {
      ...finSessions,
      ...endSessions.map((es) => es.end_date).reduce((ac, a) => ({ ...ac, [a]: null }), {})
    };

    if (event.target.value !== 'all') {
      updatedEndSessions[event.target.value] = true;
    }

    setFinSessions(event.target.value);
    setSelectedCustomers([]);
    setCurrentEndSessions(event.target.value);
    window.localStorage.setItem('choiceEndSession', JSON.stringify(event.target.value));
    setPage(0);
    handleCustomers(query, sort, currentSource, currentCampaign, callTrack, currentNewCallTrack, currentCallTrackRelance, avancement, event.target.value, relance, filters, limit, 0, modeRelance, true, true);
  };

  const handleAvancementChange = (event, value) => {
    const updatedAvancement = {
      ...avancement,
      'Pas commencé': null,
      'En cours': null,
      Terminé: null
    };

    if (typeof event.target === 'undefined') {
      if (value !== 'all') {
        updatedAvancement[value] = true;
      }

      setAvancement(updatedAvancement);
      setSelectedCustomers([]);
      setCurrentAvancement(value);
    } else {
      if (event.target.value !== 'all') {
        updatedAvancement[event.target.value] = true;
      }

      setAvancement(event.target.value);
      setSelectedCustomers([]);
      setCurrentAvancement(event.target.value);
      window.localStorage.setItem('choiceAvancement', JSON.stringify(event.target.value));
    }
    setPage(0);
    handleCustomers(query, sort, currentSource, currentCampaign, callTrack, currentNewCallTrack, currentCallTrackRelance, event.target.value, currentEndSessions, relance, filters, limit, 0, modeRelance, true, true);
  };

  const handleCallTrackChange = (event, value) => {
    const updatedCallTrack = {
      ...callTrack,
      empty: null,
      'Pas répondu': null,
      'À rappeler': null,
      'Numéro incorrect': null,
      Vente: null,
      'Non - Déjà fait': null,
      'Non - Pas intéressé': null,
      Attente: null
    };

    if (typeof event.target === 'undefined') {
      if (value !== 'all') {
        updatedCallTrack[value] = true;
      }

      setCallTrack(updatedCallTrack);
      setSelectedCustomers([]);
      setCurrentCallTrack(value);
    } else {
      if (event.target.value !== 'all') {
        updatedCallTrack[event.target.value] = true;
      }

      setCallTrack(event.target.value);
      setSelectedCustomers([]);
      setCurrentCallTrack(event.target.value);
      window.localStorage.setItem('choiceCallTrack', JSON.stringify(event.target.value));
    }
    setPage(0);
    handleCustomers(query, sort, currentSource, currentCampaign, event.target.value, currentNewCallTrack, currentCallTrackRelance, avancement, currentEndSessions, relance, filters, limit, 0, modeRelance, true, true);
  };

  // nouveau système de statut d'appel
  const handleNewCallTrackChange = (event, value) => {
    const updatedNewCallTrack = {
      ...newCallTrack,
      empty: null,
      'Vente 1 formation': null,
      'Vente 2 formation': null,
      'Vente 3 formation': null,
      'Déjà validé': null,
      'Souhaite du présentiel': null,
      'Aucun thème voulu': null,
      'Date de session trop proche': null,
      'Préfère un autre organisme': null,
      Retraite: null,
      'Numéro incorrect': null,
      'Non professionnel de santé': null,
      'Souhaite un email': null,
      Rappel: null,
      Attente: null,
      'Appel entrant': null,
      'Pas répondu': null
    };

    if (typeof event.target === 'undefined') {
      if (value !== 'all') {
        updatedNewCallTrack[value] = true;
      }

      setNewCallTrack(updatedNewCallTrack);
      setSelectedCustomers([]);
      setCurrentNewCallTrack(value);
    } else {
      if (event.target.value !== 'all') {
        updatedNewCallTrack[event.target.value] = true;
      }

      setNewCallTrack(event.target.value);
      setSelectedCustomers([]);
      setCurrentNewCallTrack(event.target.value);
      window.localStorage.setItem('choiceNewCallTrack', JSON.stringify(event.target.value));
    }
    handleCustomers(query, sort, currentSource, currentCampaign, callTrack, event.target.value, currentCallTrackRelance, avancement, currentEndSessions, relance, filters, limit, 0, modeRelance, true, true);
    setPage(0);
  };

  const handleCallTrackRelanceChange = (event, value) => {
    const updatedCallTrackRelance = {
      ...callTrackRelance,
      empty: null,
      'Pas répondu': null,
      'À rappeler': null,
      'Numéro incorrect': null,
      'Va se connecter': null,
      Annulation: null,
      'Suivi - Téléphone': null,
      'Suivi - Mail': null,
      'Suivi - SMS': null,
      Décalage: null,
    };

    if (typeof event.target === 'undefined') {
      if (value !== 'all') {
        updatedCallTrackRelance[value] = true;
      }

      setCallTrackRelance(updatedCallTrackRelance);
      setSelectedCustomers([]);
      setCurrentCallTrackRelance(value);
    } else {
      if (event.target.value !== 'all') {
        updatedCallTrackRelance[event.target.value] = true;
      }

      setCallTrackRelance(event.target.value);
      setSelectedCustomers([]);
      setCurrentCallTrackRelance(event.target.value);
      window.localStorage.setItem('choiceCallTrackRelance', JSON.stringify(event.target.value));
    }
    setPage(0);
    handleCustomers(query, sort, currentSource, currentCampaign, callTrack, currentNewCallTrack, event.target.value, avancement, currentEndSessions, relance, filters, limit, 0, modeRelance, true, true);
  };

  const handleCampaignChange = (event, value) => {
    const tempCampaign = {};
    usersCampaign.forEach((element) => {
      tempCampaign[element.id] = null;
    });
    const updatedCampaign = {
      ...campaign,
      ...tempCampaign,
      0: null
    };

    if (typeof event.target === 'undefined') {
      if (value !== 'all') {
        updatedCampaign[value] = true;
      }

      setCampaign(updatedCampaign);
      setSelectedCustomers([]);
      setCurrentCampaign(value);
    } else {
      if (event.target.value !== 'all') {
        updatedCampaign[event.target.value] = true;
      }
      setCampaign(event.target.value);
      setSelectedCustomers([]);
      setCurrentCampaign(event.target.value);
      window.localStorage.setItem('choiceCampaign', JSON.stringify(event.target.value));
    }
    setPage(0);
    handleCustomers(query, sort, currentSource, event.target.value, callTrack, currentNewCallTrack, currentCallTrackRelance, avancement, currentEndSessions, relance, filters, limit, 0, modeRelance, true, true);
  };

  const handleRelanceChange = (event) => {
    const tempRelance = {};
    usersRelance.forEach((element) => {
      tempRelance[element.id] = null;
    });
    const updatedRelance = {
      ...relance,
      ...tempRelance,
      0: null
    };

    if (event.target.value !== 'all') {
      updatedRelance[event.target.value] = true;
    }

    setRelance(event.target.value);
    setSelectedCustomers([]);
    setCurrentRelance(event.target.value);
    window.localStorage.setItem('choiceRelance', JSON.stringify(event.target.value));
    setPage(0);
    handleCustomers(query, sort, currentSource, currentCampaign, callTrack, currentNewCallTrack, currentCallTrackRelance, avancement, currentEndSessions, event.target.value, filters, limit, 0, modeRelance, true, true);
  };

  const handleTabsChange = (event, value) => {
    // Créer un objet de filtres dynamique basé sur les professions disponibles
    const updatedFilters = {};
    
    // Initialiser tous les filtres à null
    dynamicTabs.forEach(tab => {
      if (tab.value !== 'all') {
        updatedFilters[tab.value] = null;
      }
    });

    if (value !== 'all') {
      updatedFilters[value] = true;
    }
    setFilters(value);
    setSelectedCustomers([]);
    setCurrentTab(value);
    window.localStorage.setItem('choiceTabProfession', JSON.stringify(value));
    setPage(0);
    handleCustomers(query, sort, currentSource, currentCampaign, currentCallTrack, currentNewCallTrack, currentCallTrackRelance, avancement, currentEndSessions, relance, value, limit, 0, modeRelance, true, true);
  };

  const handleSortChange = (event, value) => {
    if (typeof event.target === 'undefined') {
      setSort(value);
    } else {
      setSort(event.target.value);
      window.localStorage.setItem('choiceSort', JSON.stringify(event.target.value));
    }
    setPage(0);
    handleCustomers(query, event.target.value, currentSource, currentCampaign, callTrack, currentNewCallTrack, currentCallTrackRelance, avancement, currentEndSessions, relance, filters, limit, 0, modeRelance, true, true);
  };

  const handleRegionChange = (event) => {
    const value = event.target.value;
    setCurrentRegion(value);
    window.localStorage.setItem('choiceRegion', JSON.stringify(value));
    setPage(0);
    handleCustomers(query, sort, currentSource, currentCampaign, callTrack, currentNewCallTrack, currentCallTrackRelance, avancement, currentEndSessions, relance, filters, limit, 0, modeRelance, true, true);
  };

  const handleStatutChange = (event) => {
    const value = event.target.value;
    setCurrentStatut(value);
    window.localStorage.setItem('choiceStatus', JSON.stringify(value));
    setPage(0);
    handleCustomers(query, sort, currentSource, currentCampaign, callTrack, currentNewCallTrack, currentCallTrackRelance, avancement, currentEndSessions, relance, filters, limit, 0, modeRelance, true, true);
  };

  // Ville : champ texte, recherche "contient" déclenchée après une courte pause (debounce)
  const handleVilleChange = (event) => {
    const value = event.target.value;
    setCurrentVille(value);
    window.localStorage.setItem('choiceCity', JSON.stringify(value));
    if (villeDebounceRef.current) {
      clearTimeout(villeDebounceRef.current);
    }
    villeDebounceRef.current = setTimeout(() => {
      setPage(0);
      handleCustomers(query, sort, currentSource, currentCampaign, callTrack, currentNewCallTrack, currentCallTrackRelance, avancement, currentEndSessions, relance, filters, limit, 0, modeRelance, true, true);
    }, 450);
  };

  const reinitializeFilters = () => {
    // on met à jour le localstorage
    window.localStorage.setItem('choiceTabProfession', JSON.stringify('all'));
    window.localStorage.setItem('choiceRelance', JSON.stringify('all'));
    window.localStorage.setItem('choiceCampaign', JSON.stringify('all'));
    window.localStorage.setItem('choiceCallTrackRelance', JSON.stringify('all'));
    window.localStorage.setItem('choiceNewCallTrack', JSON.stringify('all'));
    window.localStorage.setItem('choiceCallTrack', JSON.stringify('all'));
    window.localStorage.setItem('choiceAvancement', JSON.stringify('all'));
    window.localStorage.setItem('choiceEndSession', JSON.stringify('all'));
    window.localStorage.setItem('choiceSource', JSON.stringify('all'));
    window.localStorage.setItem('choiceRegion', JSON.stringify('all'));
    window.localStorage.setItem('choiceCity', JSON.stringify(''));
    window.localStorage.setItem('choiceStatus', JSON.stringify('all'));
    // on réinitialise les filtres
    setCurrentTab('all');
    setCurrentRelance('all');
    setCurrentCampaign('all');
    setCurrentCallTrackRelance('all');
    setCurrentNewCallTrack('all');
    setCurrentCallTrack('all');
    setCurrentAvancement('all');
    setCurrentEndSessions('all');
    setCurrentSource('all');
    setCurrentRegion('all');
    setCurrentVille('');
    setCurrentStatut('all');
    // Réinitialiser les filtres de profession de manière dynamique
    const updatedFilters = {};
    dynamicTabs.forEach(tab => {
      if (tab.value !== 'all') {
        updatedFilters[tab.value] = null;
      }
    });
    setFilters(updatedFilters);
    // on affiche les résultats réinitialisés
    handleCustomers('', 'lastname|asc', 'all', 'all', 'all', 'all', 'all', 'all', 'all', 'all', 'all', limit, page, modeRelance, true, true);
  };

  useEffect(() => {
    if (choiceTabProfession !== '' && choiceTabProfession !== 'undefined') {
      !loading ? handleTabsChange((event) => event, choiceTabProfession) : '';
    }
  }, [choiceTabProfession]);

  useEffect(() => {
    if (choiceSort !== '' && choiceSort !== 'undefined' && typeof choiceSort !== 'string') {
      handleSortChange((event) => event, choiceSort);
    }
    if (choiceSource !== '' && choiceSource !== 'undefined' && typeof choiceSource !== 'string') {
      handleSourceChange((event) => event, choiceSource);
    }
    if (choiceCampaign !== '' && choiceCampaign !== 'undefined' && typeof choiceCampaign !== 'string') {
      handleCampaignChange((event) => event, choiceCampaign);
    }
    if (choiceCallTrack !== '' && choiceCallTrack !== 'undefined' && typeof choiceCallTrack !== 'string') {
      handleCallTrackChange((event) => event, choiceCallTrack);
    }
    if (choiceNewCallTrack !== '' && choiceNewCallTrack !== 'undefined' && typeof choiceNewCallTrack !== 'string') {
      handleNewCallTrackChange((event) => event, choiceNewCallTrack);
    }
    if (choiceCallTrackRelance !== '' && choiceCallTrackRelance !== 'undefined' && typeof choiceCallTrackRelance !== 'string') {
      handleCallTrackRelanceChange((event) => event, choiceCallTrackRelance);
    }
    if (choiceAvancement !== '' && choiceAvancement !== 'undefined' && typeof choiceAvancement !== 'string') {
      handleAvancementChange((event) => event, choiceAvancement);
    }
    if (choiceEndSession !== '' && choiceEndSession !== 'undefined' && typeof choiceEndSession !== 'string') {
      handleEndSessionsChange((event) => event, choiceEndSession);
    }
  }, [choiceSort, choiceSource, choiceCampaign, choiceCallTrack, choiceNewCallTrack, choiceCallTrackRelance, choiceAvancement, choiceEndSession]);

  const handleQueryChange = (event, value, reason) => {
    // Ne PAS effacer la recherche sur blur / clic en dehors / fermeture du popup /
    // reduction de la fenetre : MUI declenche alors onInputChange avec reason 'reset'.
    // On ne met a jour QUE sur saisie utilisateur ('input') ou clic sur la croix ('clear').
    if (reason && reason !== 'input' && reason !== 'clear') {
      return;
    }
    // pour remettre à la première page de résultats quand on fait une recherche
    setPage(0);
    if (typeof value === 'string') {
      setQuery(value);
    } else if (event && event.target) {
      setQuery(event.target.value);
    } else if (typeof event === 'string') {
      // Si l'événement est directement une chaîne de caractères
      setQuery(event);
    }
  };

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    // moins de 3 caracteres : on vide immediatement, pas de requete
    if (query.length < 3) {
      setOptionsSearch([]);
      setCustomers([]);
      return undefined;
    }
    // debounce : on n'interroge le serveur que 400ms apres la derniere frappe
    const timer = setTimeout(() => {
      setLoadingAutocomplete(true);
      handleCustomers(query, sort, currentSource, currentCampaign, callTrack, currentNewCallTrack, currentCallTrackRelance, avancement, currentEndSessions, relance, filters, limit, page, modeRelance, false);
    }, 400);
    return () => clearTimeout(timer);
  }, [query]);

  useEffect(() => {
    if (!openAutoComplete) {
      setOptionsSearch([]);
    }
  }, [openAutoComplete]);

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
    handleCustomers(query, sort, currentSource, currentCampaign, callTrack, currentNewCallTrack, currentCallTrackRelance, avancement, currentEndSessions, relance, filters, limit, newPage, modeRelance, true, true);
  };

  const handleLimitChange = (event) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
    handleCustomers(query, sort, currentSource, currentCampaign, callTrack, currentNewCallTrack, currentCallTrackRelance, avancement, currentEndSessions, relance, filters, parseInt(event.target.value, 10), 0, modeRelance, true, true);
  };

  const filteredCustomers = applyFilters(customers, query, filters, source, campaign, callTrack, newCallTrack, callTrackRelance,
    avancement, relance, finSessions, customersEndSessions, isRelance, modeRelance);
  const sortedCustomers = applySort(filteredCustomers, sort);
  const paginatedCustomers = applyPagination(sortedCustomers, page, limit);
  const enableBulkActions = selectedCustomers.length > 0;
  const selectedSomeCustomers = selectedCustomers.length > 0
    && selectedCustomers.length < paginatedCustomers.length;
  const selectedAllCustomers = selectedCustomers.length === paginatedCustomers.length;

  const handleSelectAllCustomers = (event) => {
    setSelectedCustomers(event.target.checked
      ? paginatedCustomers.map((customer) => customer.id)
      : []);
  };

  const handleSelectOneCustomer = (event, customerId) => {
    if (!selectedCustomers.includes(customerId)) {
      setSelectedCustomers((prevSelected) => [...prevSelected, customerId]);
    } else {
      setSelectedCustomers((prevSelected) => prevSelected.filter((id) => id !== customerId));
    }
  };

  const dialogOpener = (index) => {
    setOpen(true);
    setCustomerDelete({ civility: paginatedCustomers[index].civility, firstname: paginatedCustomers[index].firstname, lastname: paginatedCustomers[index].lastname, id: paginatedCustomers[index].id });
  };

  const handleCloseDialog = () => {
    setOpen(false);
  };

  // pour afficher le loader uniquement dans le tableau
  const StyledPaper = withStyles({
    root: {
      position: 'relative'
    }
  })(Paper);
  const LimitedBackdrop = withStyles({
    root: {
      position: 'absolute',
      zIndex: 1
    }
  })(Backdrop);

  return (
    <Formik
      initialValues={{ userAssigned: null }}
      enableReinitialize
      validationSchema={Yup
        .object()
        .shape({
          addCustomer: Yup.number().nullable()
        })}
      onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
        try {
          if (!modeRelance) {
            await customerApi.assignCampaign(values.userAssigned, selectedCustomers, localStorage.getItem('accessToken'));
            setStatus({ success: true });
            setSubmitting(false);
            toast.success('Apprenants assignés !');
            selectedCustomers.forEach((id) => {
              const foundCustomer = customers.find((customer) => customer.id === id);
              foundCustomer.campaign_source_id = values.userAssigned;
              foundCustomer.userCampaignFirstname = usersCampaign.find((userCamp) => userCamp.id === values.userAssigned).firstname;
              foundCustomer.userCampaignLastname = usersCampaign.find((userCamp) => userCamp.id === values.userAssigned).lastname;
            });
          } else {
            await customerApi.assignRelance(values.userAssigned, selectedCustomers, localStorage.getItem('accessToken'));
            setStatus({ success: true });
            setSubmitting(false);
            toast.success('Apprenants assignés !');
            selectedCustomers.forEach((id) => {
              const foundCustomer = customers.find((customer) => customer.id === id);
              foundCustomer.relance_user_id = values.userAssigned;
              foundCustomer.userRelanceFirstname = usersRelance.find((userRel) => userRel.id === values.userAssigned).firstname;
              foundCustomer.userRelanceLastname = usersRelance.find((userRel) => userRel.id === values.userAssigned).lastname;
            });
          }
        } catch (err) {
          console.error(err);
          toast.error('Il y a eu un souci lors de l\'assignation !');
          setStatus({ success: false });
          setErrors({ submit: err.message });
          setSubmitting(false);
        }
      }}
    >
      {({ errors, handleSubmit, isSubmitting, touched, setFieldValue }) => (
        <form
          onSubmit={handleSubmit}
        >
          <Card 
            {...other}
            sx={{
              borderRadius: '24px',
              border: '1px solid rgba(226, 232, 240, 0.8)',
              boxShadow: '0 10px 30px -10px rgba(0,0,0,0.04)',
              backgroundColor: 'rgba(255, 255, 255, 0.95)',
              backdropFilter: 'blur(20px)',
              overflow: 'hidden',
              mb: 4,
              ...other.sx
            }}
          >
            <Dialog
              open={open}
              onClose={handleCloseDialog}
              PaperProps={{
                style: {
                  borderRadius: '24px',
                  padding: '24px',
                  maxWidth: '440px',
                  backgroundColor: 'rgba(255, 255, 255, 0.95)',
                  backdropFilter: 'blur(20px)',
                  boxShadow: '0 20px 40px -15px rgba(15, 23, 42, 0.15), 0 0 0 1px rgba(226, 232, 240, 0.8)',
                  overflow: 'hidden'
                }
              }}
            >
              <DialogContent sx={{ p: 0, textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Box
                  sx={{
                    width: '64px',
                    height: '64px',
                    borderRadius: '20px',
                    background: 'linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mb: 2.5,
                    border: '1px solid #fee2e2',
                    boxShadow: '0 8px 16px -4px rgba(239, 68, 68, 0.12)',
                    animation: 'pulse 2s infinite ease-in-out',
                    '@keyframes pulse': {
                      '0%, 100%': { transform: 'scale(1)' },
                      '50%': { transform: 'scale(1.05)' }
                    }
                  }}
                >
                  <TrashIcon sx={{ color: '#ef4444', fontSize: '32px' }} />
                </Box>

                <Typography variant="h6" sx={{ fontWeight: 800, color: '#0f172a', mb: 1, textTransform: 'none' }}>
                  Supprimer l&apos;{customerDelete.civility === 'Madame' ? 'apprenante' : 'apprenant'} ?
                </Typography>

                <DialogContentText sx={{ fontWeight: 500, color: '#64748b', fontSize: '0.925rem', lineHeight: 1.6, px: 1, mb: 3 }}>
                  Êtes-vous absolument sûr de vouloir supprimer{' '}
                  <span style={{ 
                    fontWeight: 700, 
                    color: '#ef4444',
                    background: 'rgba(239, 68, 68, 0.06)',
                    padding: '2px 8px',
                    borderRadius: '6px',
                    border: '1px dashed rgba(239, 68, 68, 0.25)',
                    display: 'inline-block',
                    marginTop: '4px',
                    marginBottom: '4px'
                  }}>
                    {customerDelete.firstname} {customerDelete.lastname}
                  </span>
                  {' '}de la session ? Cette action est irréversible.
                </DialogContentText>
              </DialogContent>
              <DialogActions sx={{ p: 0, justifyContent: 'center', gap: 1.5, width: '100%' }}>
                <Button
                  onClick={handleCloseDialog}
                  variant="outlined"
                  sx={{ 
                    borderRadius: '14px', 
                    textTransform: 'none', 
                    fontWeight: 700,
                    px: 3.5,
                    py: 1.2,
                    color: '#64748b',
                    borderColor: '#cbd5e1',
                    '&:hover': {
                      backgroundColor: '#f8fafc',
                      borderColor: '#94a3b8',
                      color: '#475569'
                    },
                    flex: 1,
                    transition: 'all 0.2s'
                  }}
                >
                  Annuler
                </Button>
                <Button
                  onClick={() => handleDeleteCustomer(customerDelete.id)}
                  variant="contained"
                  sx={{ 
                    borderRadius: '14px', 
                    textTransform: 'none', 
                    fontWeight: 700,
                    px: 3.5,
                    py: 1.2,
                    backgroundColor: '#ef4444',
                    color: '#ffffff',
                    boxShadow: '0 4px 12px 0 rgba(239, 68, 68, 0.2)',
                    '&:hover': {
                      backgroundColor: '#dc2626',
                      boxShadow: '0 6px 16px 0 rgba(239, 68, 68, 0.3)',
                      transform: 'translateY(-1px)'
                    },
                    '&:active': {
                      transform: 'translateY(0)'
                    },
                    flex: 1,
                    transition: 'all 0.2s'
                  }}
                >
                  Supprimer
                </Button>
              </DialogActions>
            </Dialog>
            <Tabs
              indicatorColor="none"
              onChange={handleTabsChange}
              scrollButtons="auto"
              textColor="primary"
              value={currentTab}
              variant="scrollable"
              sx={{
                px: 3,
                py: 2,
                borderBottom: 'none',
                '& .MuiTabs-indicator': {
                  display: 'none'
                },
                '& .MuiTabs-flexContainer': {
                  gap: '8px'
                }
              }}
            >
              {dynamicTabs.map((tab) => (
                <Tab
                  key={tab.value}
                  label={tab.label}
                  value={tab.value}
                  sx={{
                    borderRadius: '20px',
                    textTransform: 'none',
                    fontWeight: 600,
                    fontSize: '0.85rem',
                    minHeight: '36px',
                    py: 1,
                    px: 2.5,
                    backgroundColor: currentTab === tab.value ? 'rgba(59, 130, 246, 0.08)' : 'rgba(0,0,0,0.02)',
                    color: currentTab === tab.value ? '#3b82f6 !important' : '#64748b !important',
                    border: `1px solid ${currentTab === tab.value ? 'rgba(59, 130, 246, 0.15)' : 'rgba(0, 0, 0, 0.04)'}`,
                    transition: 'all 0.2s ease-in-out',
                    '&:hover': {
                      backgroundColor: currentTab === tab.value ? 'rgba(59, 130, 246, 0.12)' : 'rgba(0,0,0,0.04)',
                      transform: 'translateY(-1px)'
                    }
                  }}
                />
              ))}
            </Tabs>
            <Divider sx={{ opacity: 0.5 }} />
            <Box
              sx={{
                alignItems: 'center',
                display: 'flex',
                flexWrap: 'wrap',
                gap: 2,
                p: 3,
                backgroundColor: 'rgba(248, 250, 252, 0.4)',
                borderBottom: '1px solid rgba(226, 232, 240, 0.6)'
              }}
            >
              <Box
                sx={{
                  m: 1,
                  maxWidth: '100%',
                  width: 380
                }}
              >
                <Autocomplete
                  id="asynchronous-demo"
                  open={openAutoComplete}
                  onOpen={() => {
                    setOpenAutocomplete(true);
                    // au re-focus, les suggestions ont ete videes a la fermeture du menu :
                    // on relance la recherche pour la chaine deja saisie afin de re-afficher
                    // le(s) resultat(s) au lieu d'un menu vide.
                    if (query && query.trim().length >= 3) {
                      setLoadingAutocomplete(true);
                      handleCustomers(query, sort, currentSource, currentCampaign, callTrack, currentNewCallTrack, currentCallTrackRelance, avancement, currentEndSessions, relance, filters, limit, page, modeRelance, false);
                    }
                  }}
                  onClose={() => {
                    setOpenAutocomplete(false);
                  }}
                  getOptionLabel={(option) => `${option.id.toString()}`}
                  renderOption={(properties, option) => (
                    <Link
                      color="inherit"
                      component={RouterLink}
                      to={`/dashboard/customers/${option.id}`}
                      variant="subtitle2"
                      style={{ textDecoration: 'none' }}
                    >
                      <li
                        key={option.id}
                        {...properties}
                        style={{ padding: '10px 16px', borderRadius: '8px', transition: 'all 0.2s', display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}
                      >
                        <span style={{ fontWeight: 600, color: '#1e293b' }}>
                          {`${option.firstname} ${option.lastname}`}
                        </span>
                        <span style={{ fontSize: '0.75rem', color: '#64748b' }}>{option.email}</span>
                      </li>
                    </Link>
                  )}
                  options={optionsSearch}
                  loading={loadingAutocomplete}
                  clearOnBlur={false}
                  inputValue={query}
                  onInputChange={handleQueryChange}
                  filterOptions={(options) => options}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Recherche"
                      placeholder="Chercher un apprenant"
                      value={query}
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          borderRadius: '14px',
                          backgroundColor: '#ffffff',
                          '& fieldset': {
                            borderColor: 'rgba(226, 232, 240, 0.8)'
                          },
                          '&:hover fieldset': {
                            borderColor: 'rgba(59, 130, 246, 0.4)'
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#3b82f6',
                            boxShadow: '0 0 0 4px rgba(59, 130, 246, 0.1)'
                          }
                        }
                      }}
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {loadingAutocomplete ? (
                              <CircularProgress
                                color="inherit"
                                size={20}
                              />
                            ) : null}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon fontSize="small" style={{ color: '#64748b' }} />
                          </InputAdornment>
                        ),
                        onKeyDown: (e) => {
                          if (e.key === 'Enter') {
                            e.stopPropagation();
                            // on revient page 0 : sinon la recherche garde l'offset de la page courante
                            // et renvoie un tableau vide quand peu de resultats correspondent
                            setPage(0);
                            handleCustomers(e.target.value, sort, currentSource, currentCampaign, callTrack, currentNewCallTrack, currentCallTrackRelance, avancement, currentEndSessions, relance, filters, limit, 0, modeRelance, true, true);
                            setOpenAutocomplete(false);
                          }
                        }
                      }}
                    />
                  )}
                />
              </Box>
              {/* Filtres Région / Ville / Statut (sur une seule ligne) */}
              <Box sx={{ m: 0.5, width: 220 }}>
                <TextField
                  key="region"
                  label="Région"
                  name="region"
                  onChange={handleRegionChange}
                  select
                  SelectProps={{ native: true }}
                  value={currentRegion}
                  variant="outlined"
                  disabled={isSearching}
                  fullWidth
                  sx={{
                    width: '100%',
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '14px',
                      backgroundColor: '#ffffff',
                      '& fieldset': { borderColor: 'rgba(226, 232, 240, 0.8)' },
                      '&:hover fieldset': { borderColor: 'rgba(59, 130, 246, 0.4)' },
                      '&.Mui-focused fieldset': { borderColor: '#3b82f6' }
                    }
                  }}
                >
                  <option value="all">Toutes les régions</option>
                  {regions.map((r) => (
                    <option key={r.name} value={r.name}>
                      {r.name}
                    </option>
                  ))}
                </TextField>
              </Box>
              <Box sx={{ m: 0.5, width: 200 }}>
                <TextField
                  key="ville"
                  label="Ville"
                  name="ville"
                  placeholder="Filtrer par ville"
                  onChange={handleVilleChange}
                  value={currentVille}
                  variant="outlined"
                  disabled={isSearching}
                  fullWidth
                  sx={{
                    width: '100%',
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '14px',
                      backgroundColor: '#ffffff',
                      '& fieldset': { borderColor: 'rgba(226, 232, 240, 0.8)' },
                      '&:hover fieldset': { borderColor: 'rgba(59, 130, 246, 0.4)' },
                      '&.Mui-focused fieldset': { borderColor: '#3b82f6' }
                    }
                  }}
                />
              </Box>
              <Box sx={{ m: 0.5, width: 180 }}>
                <TextField
                  key="statut"
                  label="Statut"
                  name="statut"
                  onChange={handleStatutChange}
                  select
                  SelectProps={{ native: true }}
                  value={currentStatut}
                  variant="outlined"
                  disabled={isSearching}
                  fullWidth
                  sx={{
                    width: '100%',
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '14px',
                      backgroundColor: '#ffffff',
                      '& fieldset': { borderColor: 'rgba(226, 232, 240, 0.8)' },
                      '&:hover fieldset': { borderColor: 'rgba(59, 130, 246, 0.4)' },
                      '&.Mui-focused fieldset': { borderColor: '#3b82f6' }
                    }
                  }}
                >
                  <option value="all">Tous les statuts</option>
                  <option value="actif">Actif</option>
                  <option value="ancien">Ancien</option>
                  <option value="perdu">Perdu</option>
                </TextField>
              </Box>
              {!modeRelance && !isRelance && (
                <>
                  <Box sx={{ m: 0.5, width: 180 }}>
                    <TextField
                      key="sort"
                      label="Trier par"
                      name="sort"
                      onChange={handleSortChange}
                      select
                      SelectProps={{ native: true }}
                      value={sort}
                      variant="outlined"
                      disabled={isSearching}
                      sx={{
                        width: '100%',
                        '& .MuiOutlinedInput-root': {
                          borderRadius: '14px',
                          backgroundColor: '#ffffff',
                          '& fieldset': { borderColor: 'rgba(226, 232, 240, 0.8)' },
                          '&:hover fieldset': { borderColor: 'rgba(59, 130, 246, 0.4)' },
                          '&.Mui-focused fieldset': { borderColor: '#3b82f6' }
                        }
                      }}
                    >
                      {sortOptions.map((option) => (
                        <option
                          key={option.value}
                          value={option.value}
                        >
                          {option.label}
                        </option>
                      ))}
                    </TextField>
                  </Box>
                </>
              )}
              
              {!modeRelance && !isRelance && (
                <Box sx={{ m: 0.5, width: 220 }}>
                  <TextField
                    key="newCallTrack"
                    label="Statut d'appel"
                    name="newCallTrack"
                    onChange={handleNewCallTrackChange}
                    select
                    SelectProps={{ native: true }}
                    value={currentNewCallTrack}
                    variant="outlined"
                    disabled={isSearching}
                    sx={{
                      width: '100%',
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '14px',
                        backgroundColor: '#ffffff',
                        '& fieldset': { borderColor: 'rgba(226, 232, 240, 0.8)' },
                        '&:hover fieldset': { borderColor: 'rgba(59, 130, 246, 0.4)' },
                        '&.Mui-focused fieldset': { borderColor: '#3b82f6' }
                      }
                    }}
                  >
                    {newCallTrackOptions.map((option) => (
                      <option
                        key={option.value}
                        value={option.value}
                      >
                        {option.label}
                      </option>
                    ))}
                  </TextField>
                </Box>
              )}
              {(modeRelance || isRelance) && (
                <>
                  <Box sx={{ m: 0.5, width: 180 }}>
                    <TextField
                      key="sort"
                      label="Trier par"
                      name="sort"
                      onChange={handleSortChange}
                      select
                      SelectProps={{ native: true }}
                      value={sort}
                      variant="outlined"
                      disabled={isSearching}
                      sx={{
                        width: '100%',
                        '& .MuiOutlinedInput-root': {
                          borderRadius: '14px',
                          backgroundColor: '#ffffff',
                          '& fieldset': { borderColor: 'rgba(226, 232, 240, 0.8)' },
                          '&:hover fieldset': { borderColor: 'rgba(59, 130, 246, 0.4)' },
                          '&.Mui-focused fieldset': { borderColor: '#3b82f6' }
                        }
                      }}
                    >
                      {sortOptions.map((option) => (
                        <option
                          key={option.value}
                          value={option.value}
                        >
                          {option.label}
                        </option>
                      ))}
                    </TextField>
                  </Box>
                  <Box sx={{ m: 0.5, width: 220 }}>
                    <TextField
                      key="callTrackRelance"
                      label="Statut d'appel (Relance)"
                      name="callTrackRelance"
                      onChange={handleCallTrackRelanceChange}
                      select
                      SelectProps={{ native: true }}
                      value={currentCallTrackRelance}
                      variant="outlined"
                      disabled={isSearching}
                      sx={{
                        width: '100%',
                        '& .MuiOutlinedInput-root': {
                          borderRadius: '14px',
                          backgroundColor: '#ffffff',
                          '& fieldset': { borderColor: 'rgba(226, 232, 240, 0.8)' },
                          '&:hover fieldset': { borderColor: 'rgba(59, 130, 246, 0.4)' },
                          '&.Mui-focused fieldset': { borderColor: '#3b82f6' }
                        }
                      }}
                    >
                      {callTrackRelanceOptions.map((option) => (
                        <option
                          key={option.value}
                          value={option.value}
                        >
                          {option.label}
                        </option>
                      ))}
                    </TextField>
                  </Box>
                  <Box sx={{ m: 0.5, width: 180 }}>
                    <TextField
                      key="avancement"
                      label="Statut d'avancement"
                      name="avancement"
                      onChange={handleAvancementChange}
                      select
                      SelectProps={{ native: true }}
                      value={currentAvancement}
                      variant="outlined"
                      disabled={isSearching}
                      sx={{
                        width: '100%',
                        '& .MuiOutlinedInput-root': {
                          borderRadius: '14px',
                          backgroundColor: '#ffffff',
                          '& fieldset': { borderColor: 'rgba(226, 232, 240, 0.8)' },
                          '&:hover fieldset': { borderColor: 'rgba(59, 130, 246, 0.4)' },
                          '&.Mui-focused fieldset': { borderColor: '#3b82f6' }
                        }
                      }}
                    >
                      {avancementOptions.map((option) => (
                        <option
                          key={option.value}
                          value={option.value}
                        >
                          {option.label}
                        </option>
                      ))}
                    </TextField>
                  </Box>
                  <Box sx={{ m: 0.5, width: 180 }}>
                    <TextField
                      key="end_session"
                      label="Fin de session"
                      name="end_session"
                      onChange={handleEndSessionsChange}
                      select
                      SelectProps={{ native: true }}
                      value={currentEndSessions}
                      variant="outlined"
                      disabled={isSearching}
                      sx={{
                        width: '100%',
                        '& .MuiOutlinedInput-root': {
                          borderRadius: '14px',
                          backgroundColor: '#ffffff',
                          '& fieldset': { borderColor: 'rgba(226, 232, 240, 0.8)' },
                          '&:hover fieldset': { borderColor: 'rgba(59, 130, 246, 0.4)' },
                          '&.Mui-focused fieldset': { borderColor: '#3b82f6' }
                        }
                      }}
                    >
                      <option
                        key="all"
                        value="all"
                      >
                        Toutes
                      </option>
                      {endSessions.map((option) => (
                        <option
                          key={option.end_date}
                          value={option.end_date}
                        >
                          {moment(option.end_date).format('DD/MM/YYYY')}
                        </option>
                      ))}
                    </TextField>
                  </Box>
                </>
              )}
              {user.access_level === 0 && modeRelance && (
                <Box sx={{ m: 0.5, width: 220 }}>
                  <TextField
                    key="relance"
                    label="Relance"
                    name="relance"
                    onChange={handleRelanceChange}
                    select
                    SelectProps={{ native: true }}
                    value={currentRelance}
                    variant="outlined"
                    disabled={isSearching}
                    sx={{
                      width: '100%',
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '14px',
                        backgroundColor: '#ffffff',
                        '& fieldset': { borderColor: 'rgba(226, 232, 240, 0.8)' },
                        '&:hover fieldset': { borderColor: 'rgba(59, 130, 246, 0.4)' },
                        '&.Mui-focused fieldset': { borderColor: '#3b82f6' }
                      }
                    }}
                  >
                    {usersRelanceList.map((option) => (
                      <option
                        key={option.id}
                        value={option.id}
                      >
                        {`${option.firstname} ${option.lastname}`}
                      </option>
                    ))}
                  </TextField>
                </Box>
              )}
            </Box>

            {enableBulkActions && (
              <Box sx={{ position: 'relative', px: 3, py: 1.5 }}>
                <Box
                  sx={{
                    backgroundColor: 'rgba(15, 23, 42, 0.95)',
                    color: '#ffffff',
                    borderRadius: '16px',
                    boxShadow: '0 8px 30px rgba(0,0,0,0.2)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                    p: 1.5,
                    width: '100%',
                    zIndex: 2,
                    backdropFilter: 'blur(10px)'
                  }}
                >
                  <Checkbox
                    checked={selectedAllCustomers}
                    color="primary"
                    indeterminate={selectedSomeCustomers}
                    onChange={handleSelectAllCustomers}
                    sx={{ color: '#ffffff !important' }}
                  />
                  <Typography variant="subtitle2" sx={{ color: '#ffffff', fontWeight: 600, mr: 2 }}>
                    {selectedCustomers.length} sélectionné(s)
                  </Typography>
                  {!modeRelance && user.access_level === 0 && (
                    <Autocomplete
                      getOptionLabel={(option) => `${option.firstname} ${option.lastname}`}
                      options={usersCampaign}
                      sx={{ ml: 2, width: 220 }}
                      onChange={(e, value) => {
                        setFieldValue(
                          'userAssigned',
                          value !== null ? value.id : null
                        );
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          error={Boolean(touched.usersCampaign && errors.usersCampaign)}
                          helperText={touched.usersCampaign && errors.usersCampaign}
                          key="userAssigned"
                          label="Utilisateur à assigner"
                          name="userAssigned"
                          variant="outlined"
                          sx={{
                            '& .MuiInputLabel-root': { color: 'rgba(255,255,255,0.7)', fontSize: '0.85rem' },
                            '& .MuiOutlinedInput-root': {
                              color: '#ffffff',
                              borderRadius: '12px',
                              backgroundColor: 'rgba(255,255,255,0.08)',
                              '& fieldset': { borderColor: 'rgba(255,255,255,0.2)' },
                              '&:hover fieldset': { borderColor: 'rgba(255,255,255,0.4)' },
                              '&.Mui-focused fieldset': { borderColor: '#3b82f6' }
                            }
                          }}
                        />
                      )}
                    />
                  )}
                  {modeRelance && user.access_level === 0 && (
                    <Autocomplete
                      getOptionLabel={(option) => `${option.firstname} ${option.lastname}`}
                      options={usersRelance}
                      sx={{ ml: 2, width: 220 }}
                      onChange={(e, value) => {
                        setFieldValue(
                          'userAssigned',
                          value !== null ? value.id : null
                        );
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          error={Boolean(touched.usersRelance && errors.usersRelance)}
                          helperText={touched.usersRelance && errors.usersRelance}
                          key="userAssigned"
                          label="Utilisateur à assigner"
                          name="userAssigned"
                          variant="outlined"
                          sx={{
                            '& .MuiInputLabel-root': { color: 'rgba(255,255,255,0.7)', fontSize: '0.85rem' },
                            '& .MuiOutlinedInput-root': {
                              color: '#ffffff',
                              borderRadius: '12px',
                              backgroundColor: 'rgba(255,255,255,0.08)',
                              '& fieldset': { borderColor: 'rgba(255,255,255,0.2)' },
                              '&:hover fieldset': { borderColor: 'rgba(255,255,255,0.4)' },
                              '&.Mui-focused fieldset': { borderColor: '#3b82f6' }
                            }
                          }}
                        />
                      )}
                    />
                  )}
                  {user.access_level === 0 && (
                    <Button
                      color="primary"
                      disabled={isSubmitting}
                      sx={{ 
                        ml: 2,
                        borderRadius: '12px',
                        backgroundColor: '#3b82f6',
                        color: '#ffffff',
                        textTransform: 'none',
                        fontWeight: 600,
                        px: 3,
                        py: 1,
                        '&:hover': {
                          backgroundColor: '#2563eb'
                        }
                      }}
                      variant="contained"
                      type="submit"
                    >
                      Assigner
                    </Button>
                  )}
                  <CSVLink
                    style={{ textDecoration: 'none' }}
                    data={[customers.filter((customer) => selectedCustomers.includes(customer.id)).map((cus) => cus.email)]}
                    enclosingCharacter=""
                  >
                    <Button
                      color="inherit"
                      sx={{ 
                        ml: 2,
                        borderRadius: '12px',
                        borderColor: 'rgba(255,255,255,0.3)',
                        color: '#ffffff',
                        textTransform: 'none',
                        fontWeight: 600,
                        px: 2.5,
                        py: 1,
                        '&:hover': {
                          backgroundColor: 'rgba(255,255,255,0.1)',
                          borderColor: '#ffffff'
                        }
                      }}
                      variant="outlined"
                    >
                      Exporter les emails
                    </Button>
                  </CSVLink>
                </Box>
              </Box>
            )}
            <StyledPaper sx={{ backgroundColor: 'transparent', boxShadow: 'none' }}>
              <Scrollbar>
                <Box sx={{ minWidth: 700, p: 1 }}>
                  <Table sx={{ borderCollapse: 'separate', borderSpacing: '0 8px' }}>
                    <TableHead>
                      <TableRow sx={{ '& th': { borderBottom: 'none', color: '#64748b', fontWeight: 700, textTransform: 'uppercase', fontSize: '0.75rem', letterSpacing: '0.5px' } }}>
                        <TableCell padding="checkbox">
                          <Checkbox
                            checked={selectedAllCustomers}
                            color="primary"
                            indeterminate={selectedSomeCustomers}
                            onChange={handleSelectAllCustomers}
                          />
                        </TableCell>
                        <TableCell>Nom et Email</TableCell>
                        <TableCell>Lieu</TableCell>
                        <TableCell>Département</TableCell>
                        <TableCell>Profession</TableCell>
                        {user.access_level === 0 && !modeRelance && (
                          <TableCell>Campagne</TableCell>
                        )}
                        {user.access_level === 0 && modeRelance && (
                          <TableCell>Relance</TableCell>
                        )}
                        <TableCell>Score IA</TableCell>
                        <TableCell align="right">Actions</TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      <AnimatePresence>
                        {paginatedCustomers.map((customer, index) => {
                          const isCustomerSelected = selectedCustomers.includes(customer.id);

                          return (
                            <TableRow
                              component={motion.tr}
                              initial={{ opacity: 0, y: 12 }}
                              animate={{ opacity: 1, y: 0 }}
                              exit={{ opacity: 0, y: -12 }}
                              transition={{ duration: 0.2, delay: index * 0.02 }}
                              whileHover={{ 
                                scale: 1.005,
                                backgroundColor: 'rgba(255, 255, 255, 0.99)',
                                boxShadow: '0 4px 20px -4px rgba(0,0,0,0.06)'
                              }}
                              hover
                              key={customer.id}
                              selected={isCustomerSelected}
                              sx={{
                                border: '1px solid rgba(226, 232, 240, 0.8)',
                                borderRadius: '16px',
                                transition: 'all 0.2s',
                                '& td': {
                                  borderTop: '1px solid rgba(226, 232, 240, 0.5) !important',
                                  borderBottom: '1px solid rgba(226, 232, 240, 0.5) !important',
                                  py: 1.5,
                                  backgroundColor: isCustomerSelected ? 'rgba(59, 130, 246, 0.04) !important' : 'transparent'
                                },
                                '& td:first-of-type': {
                                  borderLeft: '1px solid rgba(226, 232, 240, 0.5) !important',
                                  borderTopLeftRadius: '16px',
                                  borderBottomLeftRadius: '16px'
                                },
                                '& td:last-of-type': {
                                  borderRight: '1px solid rgba(226, 232, 240, 0.5) !important',
                                  borderTopRightRadius: '16px',
                                  borderBottomRightRadius: '16px'
                                },
                                '&.Mui-selected': {
                                  backgroundColor: 'rgba(59, 130, 246, 0.04) !important'
                                }
                              }}
                            >
                              <TableCell padding="checkbox">
                                <Checkbox
                                  checked={isCustomerSelected}
                                  color="primary"
                                  onChange={(event) => handleSelectOneCustomer(event, customer.id)}
                                  value={isCustomerSelected}
                                />
                              </TableCell>
                              <TableCell>
                                <Box
                                  sx={{
                                    alignItems: 'center',
                                    display: 'flex'
                                  }}
                                >
                                  <Avatar
                                    src={customer.avatar}
                                    sx={{
                                      height: 40,
                                      width: 40,
                                      fontSize: '0.85rem',
                                      fontWeight: 700,
                                      boxShadow: '0 4px 10px rgba(0,0,0,0.05)',
                                      border: '2px solid #ffffff'
                                    }}
                                    {...stringAvatar(`${customer.firstname.replace(/ /g, '')} ${customer.lastname.replace(/ /g, '')}`)}
                                  />
                                  <Box sx={{ ml: 2 }}>
                                    <Link
                                      color={user.id === customer.first_source_id ? '#b32d00' : 'inherit'}
                                      component={RouterLink}
                                      to={`/dashboard/customers/${customer.id}`}
                                      variant="subtitle2"
                                      sx={{ 
                                        fontWeight: 700, 
                                        color: '#1e293b', 
                                        textDecoration: 'none',
                                        '&:hover': {
                                          color: 'primary.main',
                                          textDecoration: 'underline'
                                        }
                                      }}
                                    >
                                      {customer.firstname}
                                      {' '}
                                      {customer.lastname}
                                    </Link>
                                    <Typography
                                      color="textSecondary"
                                      variant="body2"
                                      sx={{ fontSize: '0.75rem', color: '#64748b', mt: 0.2 }}
                                    >
                                      {customer.email}
                                    </Typography>
                                  </Box>
                                </Box>
                              </TableCell>
                              <TableCell>
                                <Typography variant="body2" sx={{ fontWeight: 600, color: '#334155' }}>
                                  {customer.city || '—'}
                                </Typography>
                                <Typography variant="caption" sx={{ color: '#64748b' }}>
                                  {customer.region || ''}
                                </Typography>
                              </TableCell>
                              <TableCell>
                                <Typography variant="body2" sx={{ fontWeight: 600, color: '#334155' }}>
                                  {customer.department || '—'}
                                </Typography>
                              </TableCell>
                              <TableCell>
                                <Box
                                  sx={{
                                    display: 'inline-flex',
                                    px: 1.5,
                                    py: 0.5,
                                    borderRadius: '8px',
                                    backgroundColor: 'rgba(59, 130, 246, 0.06)',
                                    color: '#2563eb',
                                    fontSize: '0.75rem',
                                    fontWeight: 700
                                  }}
                                >
                                  {customer.profession || 'Non renseigné'}
                                </Box>
                              </TableCell>
                              {user.access_level === 0 && !modeRelance && (
                                <TableCell>
                                  {customer.userCampaignFirstname ? (
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                      <Box sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: '#10b981' }} />
                                      <Typography variant="body2" sx={{ fontWeight: 600, color: '#0f766e' }}>
                                        {customer.userCampaignFirstname} {customer.userCampaignLastname}
                                      </Typography>
                                    </Box>
                                  ) : (
                                    <Typography variant="body2" sx={{ color: '#94a3b8', fontStyle: 'italic' }}>
                                      Non assigné
                                    </Typography>
                                  )}
                                </TableCell>
                              )}
                              {user.access_level === 0 && modeRelance && (
                                <TableCell>
                                  {customer.userRelanceFirstname ? (
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                      <Box sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: '#8b5cf6' }} />
                                      <Typography variant="body2" sx={{ fontWeight: 600, color: '#6d28d9' }}>
                                        {customer.userRelanceFirstname} {customer.userRelanceLastname}
                                      </Typography>
                                    </Box>
                                  ) : (
                                    <Typography variant="body2" sx={{ color: '#94a3b8', fontStyle: 'italic' }}>
                                      Non assigné
                                    </Typography>
                                  )}
                                </TableCell>
                              )}
                              <TableCell>
                                {(() => {
                                  const sc = relationScores[customer.id];
                                  if (!sc) {
                                    return <Box sx={{ width: 90, height: 8, borderRadius: '4px', backgroundColor: 'rgba(148,163,184,0.18)' }} />;
                                  }
                                  const col = scoreIaColor(sc.score);
                                  const flags = (sc.flags || []).filter((f) => f.key !== 'tendue');
                                  return (
                                    <Box sx={{ minWidth: 108 }}>
                                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: 0.4 }}>
                                        <Box sx={{ minWidth: 26, px: 0.75, py: 0.2, borderRadius: '7px', backgroundColor: `${col}1f`, color: col, fontWeight: 800, fontSize: '0.78rem', textAlign: 'center' }}>
                                          {sc.score}
                                        </Box>
                                        <Typography sx={{ fontSize: '0.78rem', fontWeight: 600, color: col }}>{sc.label}</Typography>
                                      </Box>
                                      <Box sx={{ width: 90, height: 5, borderRadius: '3px', backgroundColor: 'rgba(148,163,184,0.2)', overflow: 'hidden' }}>
                                        <Box sx={{ width: `${sc.score}%`, height: '100%', backgroundColor: col, borderRadius: '3px' }} />
                                      </Box>
                                      {flags.length > 0 && (
                                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.4, mt: 0.5 }}>
                                          {flags.map((f) => (
                                            <Box
                                              key={f.key}
                                              sx={{
                                                px: 0.6, py: 0.1, borderRadius: '5px', fontSize: '0.62rem', fontWeight: 600,
                                                backgroundColor: f.key === 'nocontact' ? 'rgba(239,68,68,0.1)' : 'rgba(249,115,22,0.1)',
                                                color: f.key === 'nocontact' ? '#dc2626' : '#ea580c'
                                              }}
                                            >
                                              {f.label}
                                            </Box>
                                          ))}
                                        </Box>
                                      )}
                                    </Box>
                                  );
                                })()}
                              </TableCell>
                              <TableCell align="right">
                                <IconButton
                                  component={RouterLink}
                                  to={`/dashboard/customers/${customer.id}`}
                                  sx={{
                                    color: '#3b82f6',
                                    backgroundColor: 'rgba(59, 130, 246, 0.05)',
                                    mr: 1,
                                    borderRadius: '10px',
                                    '&:hover': {
                                      backgroundColor: 'rgba(59, 130, 246, 0.15)',
                                      transform: 'translateY(-1px)'
                                    },
                                    transition: 'all 0.2s'
                                  }}
                                >
                                  <ArrowRightIcon fontSize="small" />
                                </IconButton>
                                <IconButton
                                  onClick={() => dialogOpener(index)}
                                  disabled={!(user.access_level === 0 || user.id_service === 4)}
                                  sx={{
                                    color: '#ef4444',
                                    backgroundColor: 'rgba(239, 68, 68, 0.05)',
                                    borderRadius: '10px',
                                    '&:hover': {
                                      backgroundColor: 'rgba(239, 68, 68, 0.15)',
                                      transform: 'translateY(-1px)'
                                    },
                                    transition: 'all 0.2s'
                                  }}
                                >
                                  <TrashIcon fontSize="small" />
                                </IconButton>
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </AnimatePresence>
                      <LimitedBackdrop
                        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1, borderRadius: '24px' }}
                        open={isLoading}
                      >
                        <CircularProgress color="inherit" />
                      </LimitedBackdrop>
                    </TableBody>
                  </Table>
                </Box>
              </Scrollbar>
            </StyledPaper>
            <TablePagination
              component="div"
              count={numberCustomers}
              onPageChange={handlePageChange}
              onRowsPerPageChange={handleLimitChange}
              page={page}
              rowsPerPage={limit}
              rowsPerPageOptions={[15, 25, 50]}
              SelectProps={{
                disabled: isSearching
              }}
              backIconButtonProps={
                isSearching
                  ? { disabled: isSearching } : undefined
              }
              nextIconButtonProps={
                isSearching
                  ? { disabled: isSearching } : undefined
              }
              sx={{
                borderTop: '1px solid rgba(226, 232, 240, 0.6)',
                px: 2,
                py: 1,
                color: '#64748b',
                '& .MuiTablePagination-select': {
                  fontWeight: 600,
                  color: '#1e293b'
                }
              }}
            />
          </Card>
        </form>
      )}
    </Formik>
  );
};

CustomerListTable.propTypes = {
  customers: PropTypes.array.isRequired,
  usersCampaign: PropTypes.array.isRequired,
  modeRelance: PropTypes.bool.isRequired,
  isRelance: PropTypes.bool.isRequired,
  usersRelance: PropTypes.array.isRequired,
  endSessions: PropTypes.array,
  customersEndSessions: PropTypes.array,
  choiceTabProfession: PropTypes.string,
  choiceSort: PropTypes.string,
  choiceSource: PropTypes.string,
  choiceCampaign: PropTypes.string,
  choiceCallTrack: PropTypes.string,
  choiceNewCallTrack: PropTypes.string,
  choiceCallTrackRelance: PropTypes.string,
  choiceAvancement: PropTypes.string,
  choiceEndSession: PropTypes.string,
  query: PropTypes.string,
  setQuery: PropTypes.func,
  setCustomers: PropTypes.func,
  numberCustomers: PropTypes.number,
  setNumberCustomers: PropTypes.func,
  loading: PropTypes.bool,
  loadingFilter: PropTypes.bool,
  page: PropTypes.number,
  limit: PropTypes.number,
  setPage: PropTypes.func,
  setLimit: PropTypes.func,
  relance: PropTypes.object,
  setRelance: PropTypes.func

};

export default CustomerListTable;
